import { useEffect, useRef } from 'preact/hooks';
import QRCode from 'qrcode-svg';
import { Modal } from '@/ui/Modal.jsx';
import { notify } from '@/store/ui';
import css from './MarkingModal.module.css';

export function MarkingModal({ item, onClose }) {
  const containerRef = useRef(null);
  const codes = item?.marking_codes || [];

  useEffect(() => {
    if (!containerRef.current) return;
    const qrEls = containerRef.current.querySelectorAll('[data-qr-code]');
    qrEls.forEach((el) => {
      const code = el.getAttribute('data-qr-code');
      try {
        const qr = new QRCode({ content: code, padding: 1, width: 160, height: 160, ecl: 'M' });
        // SVG напрямую через innerHTML опасно — но QR-библиотека возвращает свой SVG-строку,
        // никакого пользовательского ввода тут нет. Тем не менее парсим в DOM безопасно.
        const parser = new DOMParser();
        const doc = parser.parseFromString(qr.svg(), 'image/svg+xml');
        const svg = doc.documentElement;
        el.replaceChildren(svg);
      } catch (e) {
        console.warn('QR render failed', e);
      }
    });
  }, [codes]);

  async function copy(code) {
    try {
      await navigator.clipboard?.writeText(code);
      notify('Код скопирован');
    } catch {
      notify('Не удалось скопировать код');
    }
  }

  return (
    <Modal open title={item?.name} size="lg" onClose={onClose}>
      <div ref={containerRef}>
        {codes.length === 0 ? (
          <p class="empty-state">Коды маркировки появятся после отгрузки заказа.</p>
        ) : (
          <>
            <p class={css.summary}>
              Всего кодов: <strong>{codes.length}</strong>
            </p>
            <div class={css.grid}>
              {codes.map((c, i) => (
                <div key={i} class={css.item}>
                  <div class={css.qr} data-qr-code={c.code} />
                  <code class={css.code}>{c.code}</code>
                  <button type="button" class="btn btn-secondary btn-sm" onClick={() => copy(c.code)}>
                    Копировать
                  </button>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}
